import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContextService } from 'projects/cross-study-portal-lib/src/public-api';

@Component({
  selector: 'mcp-study-select',
  templateUrl: './study-select.component.html',
  styleUrls: ['./study-select.component.scss'],
})
export class StudySelectComponent implements OnInit {
  get hasStudyMembership(): boolean {
    return ((this.context.instance?.totalActiveStudies || 0) > 0);
  }

  get isOnToolbar(): boolean {
    return (this.route.routeConfig?.path !== 'studySelector');
  }

  constructor(private window: Window, private context: ContextService, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    if (this.route.routeConfig?.path === 'studySelector') {
      this.onStudySelect();
    }
  }

  onStudySelect(): void {
    if (this.context.instance?.studySelectorUrl) {
      this.window.location.href = this.context.instance?.studySelectorUrl;
    }
  }
}
